import { proxy } from 'valtio';

export type DiagramSyncStatus = 'syncing' | 'synced' | 'error' | null;

const syncingState = proxy<{
    status: DiagramSyncStatus;
    error: string | null;
}>({
    status: null,
    error: '',
});

export { syncingState };
